export enum OnlineStatusEnums {
    UNKNOWN = 0,
    ONLINE,
    NO_NETWORK,
    NOT_LOGGED_IN,
    API_ERROR,
}
